import { render, staticRenderFns } from "./CameraPageHeader.vue?vue&type=template&id=e2f5d22a&scoped=true&"
import script from "./CameraPageHeader.vue?vue&type=script&lang=ts&"
export * from "./CameraPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageHeader.vue?vue&type=style&index=0&id=e2f5d22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f5d22a",
  null
  
)

export default component.exports